/**
 * 日志详情
 */
import React, { useImperativeHandle, useState } from 'react';
import { Modal, Spin, Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';
import ReactJson from 'react-json-view';
import copy from 'copy-to-clipboard';

import { getOrderLogDetail } from '@/api/order';

import styles from './index.module.scss';

export interface DetailModalRef {
  showModal: (id: string) => void;
}

interface IProps {
  innerRef: React.Ref<DetailModalRef>;
}

// json转换
const formatJSONText = (text) => {
  try {
    const data = JSON.parse(text);
    if (data instanceof Object) return data;
  } catch (_) {
    //
  }
  return { data: text };
};

const Index: React.FC<IProps> = (props) => {
  const [visible, setVisible] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [modalData, setModalData] = useState({
    traceId: null,
    inputCode: '',
    inputJSON: {},
    outputCode: '',
    outputJSON: {},
  });

  const closeModal = () => {
    setVisible(false);
  };

  // 复制文本
  const copyText = (val: string) => {
    try {
      const isSuccess = copy(val);
      if (isSuccess) {
        message.success(intl.get('cmp_order_share_btn_message_copy_success'));
        return;
      }
    } catch (e) {
      //
    }
    message.error(intl.get('cmp_order_share_btn_message_copy_fail'));
  };

  // 复制入参
  const copyInputData = () => {
    copyText(modalData.inputCode);
  };

  // 复制出参
  const copyOutputData = () => {
    copyText(modalData.outputCode);
  };

  useImperativeHandle(
    props.innerRef,
    () => ({
      showModal: async (id) => {
        setVisible(true);
        setLoadingStatus(true);
        try {
          const res = await getOrderLogDetail({ id });
          const { traceId, inParam, outParam } = res.data;
          setModalData({
            traceId,
            inputJSON: formatJSONText(inParam),
            inputCode: inParam,
            outputJSON: formatJSONText(outParam),
            outputCode: outParam,
          });
        } catch (_) {
          //
        }
        setLoadingStatus(false);
      },
    }),
    [],
  );

  return (
    <Modal
      title={intl.get('order_operation_log_detail')}
      open={visible}
      width={980}
      onCancel={closeModal}
      destroyOnClose
      maskClosable={false}
      wrapClassName={styles.logModalContainer}
      footer={
        <Button type="primary" onClick={closeModal}>
          {intl.get('app_confirm_close_btn')}
        </Button>
      }
    >
      <Spin spinning={loadingStatus}>
        <div className={styles.traceId}>
          <div>TraceId：</div>
          <div>{modalData.traceId}</div>
        </div>
        <div className={styles.logDetailWrapper}>
          <div className={styles.detailContent}>
            <Button type="link" className={styles.copyButton} onClick={copyInputData}>
              <CopyOutlined />
            </Button>
            <div className={styles.codeWrapper}>
              <ReactJson
                name={null}
                displayDataTypes={false}
                enableClipboard={false}
                displayObjectSize={false}
                src={modalData.inputJSON}
              />
            </div>
          </div>
          <div className={styles.detailContent}>
            <Button type="link" className={styles.copyButton} onClick={copyOutputData}>
              <CopyOutlined />
            </Button>
            <div className={styles.codeWrapper}>
              <ReactJson
                name={null}
                displayDataTypes={false}
                enableClipboard={false}
                displayObjectSize={false}
                src={modalData.outputJSON}
              />
            </div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default Index;
